import React, {useEffect, useState} from 'react'
import {COMMON_ROUTER} from "../../../../constants";

export default (props) => {
  const [count, setCount] = useState(3)

  useEffect(() => {
    let timer = setInterval(() => {
      if (count === 0) {
        props.history.push(COMMON_ROUTER + '/activitys')
      } else {
        let counts = count - 1
        setCount(counts)
      }
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [count])

  const back = () => {
    props.history.push(COMMON_ROUTER + '/activitys')
  }

  return (
    <div style={{display: "flex", flex: 1, fontSize: '16px', justifyContent: "center", alignIitems: "center"}}>
      恭喜添加活动商品成功,<span style={{color: "#33bc22"}}>{count}s</span>后自动返回
      <a style={{marginLeft: "30px"}} onClick={() => back()}>立即返回</a>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/activitys/add-activity/success/index.js